export enum BlockTypes {
  BlockSurvey = 'BlockSurvey',
  BlockRichText = 'BlockRichText',
  BlockTask = 'BlockTask',
  BlockMultimedia = 'BlockMultimedia',
  BlockEvaluation = 'BlockEvaluation',
  BlockScorm = 'BlockScorm',
  BlockMeeting = 'BlockMeeting',
}
